import {
  Dices,
  Dog,
  Flame,
  Gamepad2,
  MoveHorizontal,
  Target,
  Trees,
  Tv,
  Users,
  WashingMachine,
  Wifi,
} from "lucide-react";
import { MaskReveal, Reveal } from "../Reveal";
import { PHOTO_SIZES, PHOTOS } from "../images";

const AMENITIES = [
  { icon: Users, label: "Recreation and Meeting Hall" },
  { icon: Gamepad2, label: "Game Room" },
  { icon: MoveHorizontal, label: "Shuffleboard" },
  { icon: Dices, label: "Poker Table" },
  { icon: Target, label: "Dartboard" },
  { icon: Trees, label: "Covered Picnic Area" },
  { icon: Flame, label: "Barbecue Pits" },
  { icon: WashingMachine, label: "Onsite Laundry" },
  { icon: Wifi, label: "Wi-Fi" },
  { icon: Tv, label: "Cable Television" },
  { icon: Dog, label: "Off-Leash Pet Area" },
] as const;

export function AboutCommunity() {
  const photo = PHOTOS.clubhouse;

  return (
    <section
      className="bg-forest-deep py-24 text-cream sm:py-28 lg:py-32"
      aria-labelledby="community-title"
    >
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-[1.1fr_1fr] lg:items-end lg:gap-20">
          <Reveal>
            <p className="eyebrow text-sand">More Than a Place to Park</p>
            <h2
              id="community-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
            >
              Comfort, Community and Room to Gather
            </h2>
            <div className="mt-6 max-w-xl space-y-4 text-base leading-relaxed text-cream/80 sm:text-lg">
              <p>
                Guests can enjoy a recreation hall that can be used for meetings, group activities,
                and community gatherings. Throughout the year, Amigo Inn brings guests together for
                occasions such as Thanksgiving, Christmas, New Year&apos;s, the Super Bowl,
                Valentine&apos;s Day, and other seasonal events.
              </p>
              <p>
                The property also includes a game room with shuffleboard, a poker table, and a
                dartboard. A covered picnic area with barbecue pits, tables, and convenient
                facilities provides another comfortable place to relax and spend time together
                outdoors.
              </p>
            </div>
          </Reveal>

          <MaskReveal className="media-zoom rounded-sm">
            <img
              src={photo.src}
              srcSet={photo.srcSet}
              sizes={PHOTO_SIZES.half}
              alt={photo.alt}
              width={photo.width}
              height={photo.height}
              loading="lazy"
              decoding="async"
              className="aspect-[16/10] w-full rounded-sm object-cover"
            />
          </MaskReveal>
        </div>

        <ul className="mt-16 grid gap-x-10 sm:grid-cols-2 lg:grid-cols-3">
          {AMENITIES.map((item, i) => (
            <Reveal as="li" key={item.label} delay={(i % 3) * 0.05}>
              <div className="flex items-center gap-4 border-b border-cream/15 py-5">
                <item.icon className="size-5 shrink-0 text-sand" aria-hidden="true" />
                <span className="text-sm font-medium leading-snug text-cream/95">{item.label}</span>
              </div>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
